<template>
  <div>
    <div class="col-md-6">
      <card class="card" title="Register a new application">
        <div class="row">
          <div class="col">
            <fg-input
              type="text"
              label="Application name *"
              placeholder="Example golf club website"
              v-model="form.name"
            >
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <fg-input
              type="text"
              label="Homepage URL *"
              placeholder="https://your-website-url.com"
              v-model="form.redirect"
            >
            </fg-input>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col text-right">
            <div class="btn-group">
              <p-button type="danger" @click.prevent.native="$router.go(-1)"> Cancel </p-button>
              <p-button type="success" @click.prevent.native="save()"> Save </p-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import CustomClientController from '@/controllers/PublicData/CustomClientController';

export default {
  name: 'CreateApplication',
  data() {
    return {
      form: {},
    };
  },
  methods: {
    async save() {
      try {
        await CustomClientController.store(this.form);
        await this.$router.push({ name: 'Applications' });
        this.$notify({
          type: 'success',
          title: 'Successfully created!',
        });
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
  },
};
</script>

<style scoped></style>
